import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ParticipantDetailsPage, { getDefaultUI } from "components/pages/ParticipantDetailsPage";
import Classes, { Participant } from "model";

export default function CaptureParticipantDetailsPartialRoutingEntered(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const data = BCMSStateManagerCRUD.init({ participant: Participant.init({ participantType: "standard", accountType: "Checking", status: "active" }) })
    .update([ "participant", "participantName" ], "Thomas Jefferson")
    .update([ "participant", "participantEmail" ], "tjefferson@presidentsinc.com")
    .update([ "participant", "nickname" ], "TJefferson")
    .update([ "participant", "routing" ], "999888766")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "routingSelectIsActive" ], true)
    .submit();

    return <ParticipantDetailsPage data={ data } ui={ ui } />
}